module.exports = __webpack_public_path__ + "static/media/pool.fc264106.svg";